import { Guid } from "@/lib"

export class Project{

    pid:Guid = ''
    name = ''    
}